<div class="flex flex-col h-full gap-6">
	<div>
		<div class="h-6 skeleton__wrapper w-32 mb-3"></div>

		<div class="h-8 bg-gray-200 rounded-full animate-pulse w-24"></div>
	</div>

	<div>
		<div class="h-6 skeleton__wrapper w-36 mb-3"></div>

		<div class="flex justify-between mb-2">
			<div class="h-4 skeleton__wrapper w-24"></div>
			<div class="h-4 skeleton__wrapper w-20"></div>
		</div>

		<div class="flex justify-between mb-2">
			<div class="h-4 skeleton__wrapper w-16"></div>
			<div class="h-4 skeleton__wrapper w-72"></div>
		</div>

		<div class="flex justify-between mb-2">
			<div class="h-4 skeleton__wrapper w-16"></div>
			<div class="h-4 skeleton__wrapper w-64"></div>
		</div>

		<div class="flex justify-between">
			<div class="h-4 skeleton__wrapper w-32"></div>
			<div class="h-4 skeleton__wrapper w-28"></div>
		</div>
	</div>

	<div>
		<div class="h-6 skeleton__wrapper w-40 mb-3"></div>

		<div class="flex justify-between mb-2">
			<div class="h-4 skeleton__wrapper w-28"></div>
			<div class="h-4 skeleton__wrapper w-36"></div>
		</div>

		<div class="flex justify-between">
			<div class="h-4 skeleton__wrapper w-12"></div>
			<div class="h-4 skeleton__wrapper w-64"></div>
		</div>
	</div>

	<app-quote-coverage-card-skeleton />
	<app-quote-coverage-card-skeleton />
</div>
